<template>
  <v-card>
    <v-card-title>Booking Reminders</v-card-title>
    <v-card-subtitle>Adjust the reminders that are sent to customers prior to their arrival</v-card-subtitle>
    <v-card-text>
      <v-switch
        label="Email"
        v-model="email"
        hide-details
      />
      <v-textarea
        label="Email Reminder Template"
        class="mt-4"
        v-model="emailText"
        v-if="email"
        outlined
        hide-details
        filled
      />
    </v-card-text>
    <v-divider />
    <v-card-text>
      <v-switch
        label="SMS"
        v-model="sms"
        hide-details
      />
      <v-textarea
        label="SMS Reminder Template"
        class="mt-4"
        v-model="smsText"
        hide-details
        outlined
        filled
        v-if="sms"
      />
    </v-card-text>
    <v-card-actions>
      <v-btn
        class="primary"
        block
        large
        disabled
      >
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
	name: 'BookingReminders',
	data() {
		return {
			email: false,
			sms: false,
			emailText: '',
			smsText: ''
		}
	}
}
</script>
